import React, { useState, useEffect } from 'react'
import store from '../../../store';
import { connect } from "react-redux";
import Input from './input/Input'
import { ExIcon } from './svg';
import AccountLoader from '../../manageAccount/accountLoader';
import Button from './input/Button';
import Alert from './Alert';
import { updatePnrEnqiryData, updatePnrEnqiryTripData } from '../../../actions/search-actions';
import Card from './card';
import { resp } from '../resp';
import { GetRequest, stopTimer, countdown } from './helper';
import { apiUrl } from './constants';
import Bookingcard from './bookingcard';
import GInput from '../../common/input/ginput';
import { NO_RECENT_BOOKING, OB_REF_GEN, OB_REF_NUM, MOB_NUM, MOB_NUM_ERR, ENTER_OTP, VERIFY, RESEND_OTP_IN, RESEND_OTP_NOW, ENTER_VALID_OTP, t } from '../../../translations/pnrEnquiry/Obr';
import { SEARCH,LOCKOTP_MSG, tCommon } from '../../../translations/Common';
import OtpForm from '../../common/cancelRequestForm';
import { renderImg } from '../../common/icons/img';
import { generateCaptchaToken,verifyCaptchaToken } from '../../common/helper';
import { captcha_key } from '../../common/constants';

const Obr = (props) => {
    const propdata = store.getState();
    const pnrEnquiryData = propdata.search.pnrEnquiryData;
    const [user, setUser] = useState({ obr: props.val || '', mobile: props.mobile || '', otp: '' });
    const [loader, setLoader] = useState(false);
    const [alert, setAlert] = useState({ show: false, msg: '' });
    const [mobile, setMobile] = useState('');

    const [otpSent, setOtpSent] = useState(false);
    const [resend, setResend] = useState("");
    const [password, setPassword] = useState("");
    const [togglePassword, setTogglePassword] = useState(false);
    const [otpRequest, setOtpRequest] = useState(false);
    const [invalidOTP, setInvalidOTP] = useState(false);
    const [isLockedOTP, setIsLockedOTP] = useState(false);

    useEffect(() => {
        stopTimer();
    }, [])
    const handleChange = (val, param) => {
        user[param] = val;
        setUser({ ...user });
    }
    const handleAlert = (msg = false) => {
        if (msg) {
            setAlert({ show: true, msg });
        } else {
            setAlert({ show: false, msg: '' })
        }
    }

    const generateOtp = () => {
        const mobile = user.mobile;
        if (mobile && String(mobile).length === 10 && mobile > 6000000000) {
            setLoader(true);
            const url = `${apiUrl.generateOTPV2}?mobileNo=${mobile}&type=obref`;
            GetRequest(url).then(res => {
                if (res.Success === true) {
                    countdown('mobileClock', 3, 0, setResend);
                    setOtpRequest(true);
                    setOtpSent(true);
                    setResend("disable");
                }else{
                    setAlert({ show: true, msg: res.ErrorMessage})   
                }
                setLoader(false);
            })

        } else {
            setAlert({ show: true, msg: 'Please enter valid Mobile no' })
        }
        user.otp = '';
        setPassword("");
        setUser({ ...user });
    }

    const verifyOtp = () => {

        generateCaptchaToken(captcha_key).then(captchaToken => {
            verifyCaptchaToken(captchaToken).then((res) => {

                const mobile = user.mobile;
                const obr = `${user.obr}`;
        
                setInvalidOTP(false);
                setIsLockedOTP(false);
                setLoader(true);
        
                const url = `${apiUrl.validateOTPV2}?OTP=${password}&mobileNo=${mobile}`;
                GetRequest(url).then(result => {
                    setLoader(false);
                    if (result.Success) {
                        stopTimer();
                        // getStatusDetails(pnr);
                        fetchObDtls(user.obr);
                    } else {
                        result?.IsLocked ? setIsLockedOTP(true) : setInvalidOTP(true);
                    }
                }).catch((err) => {
                    console.log("err", err);
                    setLoader(false);
                });
            })
        });

    }

    const fetchObDtls = (obr) => {
        if (obr) {
            setLoader(true);
            if (obr.includes('OB') || obr.includes('ob')) {
                // do nothing
            } else {
                obr = `${obr}`;
            }
            let url = `${apiUrl.statusDetails}?searchVal=${obr}&mode=O&obRef=${obr}`;
            GetRequest(url).then(result => {
                setLoader(false);
                setOtpRequest(false);
                // result = resp;
                if (result.IsSuccess) {
                    let res = result.Data;
                    store.dispatch(updatePnrEnqiryData(res));
                    store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} }));
                } else {
                    if (result.ErrorMessage) {
                        setAlert({ show: true, msg: result.ErrorMessage })
                    }
                    store.dispatch(updatePnrEnqiryData(false));
                    store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} }));
                }
            }).catch((err) => {
                console.log("err", err);
                setLoader(false);
            })
        } else {
            setAlert({ show: true, msg: 'Please enter OB Reference Number' })
        }
    }

    const getParseData = (data) => {

        let rs = [];
        data.forEach((el, index) => {
            let resp = {};
            if (el.pnrNo || el.OldFormatPNR) {
                resp.JourneyDate = el.JourneyDate;
                resp.TripCode = el.TripCode;
                resp.BusType = el.BusDetails[0].BusType;
                resp.ArrivalTime = el.BusDetails[0].DropoffTime;
                resp.BookingDateTime = el.BookingTime;
                resp.BookingRefNo = el.BookingStatus === 'Payment Pending' ? "" : el.pnrNo;
                resp.DepartureTime = el.BusDetails[0].PickupTime;
                resp.DropoffID = el.BusDetails[0].DropoffID;
                resp.DroppoffName = el.BusDetails[0].DropOffName;
                resp.FromCityName = el.BusDetails[0].FromCity;
                resp.ToCityName = el.BusDetails[0].ToCity;
                resp.FromCityID = el.BusDetails[0].FromCityID;
                resp.ToCityID = el.BusDetails[0].ToCityID;
                resp.PickupID = el.BusDetails[0].PickupID;
                resp.PickupName = el.BusDetails[0].PickupName;
                resp.RouteCode = el.RouteCode;
                resp.PNR = el.BookingStatus === 'Payment Pending' ? "" : el.OldFormatPNR;
                resp.mobile = el.MobileNo;
                resp.BookingStatus = ((el.BookingStatus === 'Payment Pending' || el.BookingStatus === 'PDBF' || el.BookingStatus === 'NA') ? el.BookingStatus : el.BookingStatus === 'Booking' ? "B" : "C");
                resp.showCancel = false;
                resp.showEdit = false;
                resp.viewBokking = false;
                resp.returnBooking = data.length === 2 && index === 0 ? true : false
            }
            rs.push(resp);
        });
        return rs;
    }

    const handelCloseOtpForm = (val) => {
        stopTimer();
        setOtpRequest(val);
    }
    
    return (
        <>
            {loader && <AccountLoader />}
            {!pnrEnquiryData && <div className="bookingStatus-inputs">
                <div className="inputs">

                    <div className='secInput' style={{ width: '45%' }}>
                        <Input type='tel' label={t(OB_REF_NUM)} onChange={(val) => handleChange(val, 'obr')} autoFocus={true}
                            errMsg={t(OB_REF_NUM)} value={user.obr} />
                    </div>

                    <div className='secInput' style={{ width: '45%' }}>
                        <Input type='tel' label={t(MOB_NUM)} onChange={(val) => handleChange(val, 'mobile')} validation={'mobile'}
                            errMsg={t(MOB_NUM_ERR)} value={user.mobile} />
                    </div>

                    <div className="send-button">
                        <Button text={tCommon(SEARCH)} className={`button ${(String(user.obr).length > 4 && String(user.mobile).length === 10) ? `active` : `disable`}`} extraStyle={{ "height": "48px" }} onClick={() => generateOtp()} />
                    </div>
                </div>
                <div className="bookingStatus-message">
                    <div className="message" style={{ display: 'flex', marginTop: '6px' }}>
                        {

                            <><span style={{ marginRight: '8px', marginTop: '-2px', }}><ExIcon /></span><span>{t(OB_REF_GEN)}</span> <span id="emailClock" style={{ color: "red", marginLeft: '4px' }}></span></>

                        }
                    </div>
                </div>
            </div>
            }
            {
                pnrEnquiryData && pnrEnquiryData.length > 0 &&
                <div className='booking-cards'>
                    <Bookingcard cardData={getParseData(pnrEnquiryData)} mobile={mobile} />
                    {/* <Card val={pnrEnquiryData[0]} /> */}
                </div>
            }
            {
                pnrEnquiryData && pnrEnquiryData.length === 0 &&
                <div className='booking-cards'>
                    <div style={{ fontSize: '16px', fontWeight: '500', textAlign: 'center' }}>{t(NO_RECENT_BOOKING)}</div>
                </div>
            }
            {
                alert.show &&
                <Alert msg={alert.msg} error={true} close={() => handleAlert()} />
            }

            {
                otpRequest &&

                <OtpForm

                    msg={
                        < div
                            className="booking--inquiry"
                            style={{ justifyContent: "center" }}
                        >
                            <GInput
                                type={togglePassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e)}
                                label={t(ENTER_OTP)}
                                key={"password"}
                                icon2={renderImg("view-icon")}
                                onIconClick={() =>
                                    setTogglePassword(!togglePassword)
                                }
                                autoFocus={true}
                                validation="password"
                                max={6}
                            />
                            <div className="cancel--request--btn" onClick={verifyOtp}>{t(VERIFY)}</div>
                            <div className="bookingStatus-message">
                                <div className="message" style={{ display: 'flex', paddingTop: '10px', justifyContent: 'center' }}>
                                    {
                                        resend === "" ? "" :
                                            resend === "Resend" ? <span style={{ color: 'var(--ksrtcThColor1)', cursor: 'pointer' }} onClick={generateOtp}>{t(RESEND_OTP_NOW)}</span> :
                                                <><span style={{ marginRight: '8px', marginTop: '-2px' }}><ExIcon /></span><span> {t(RESEND_OTP_IN)} </span> <span id="mobileClock" style={{ color: "red", marginLeft: '4px' }}></span></>
                                    }
                                </div>
                            </div>
                            {
                                invalidOTP && (
                                    <div className="bookingStatus-otp-message">
                                        <div className="otp-message">
                                            <span>{t(ENTER_VALID_OTP)}</span>
                                        </div>
                                    </div>
                                )
                            }
                            {
                                isLockedOTP && (
                                    <div className="bookingStatus-otp-message">
                                        <div className="otp-message">
                                            <span>{tCommon(LOCKOTP_MSG)}</span>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    }

                    onClick={handelCloseOtpForm}  

                />

            }
        </>

    )
}

const mapStateToProps = function (store) {
    return store;
};
export default connect(mapStateToProps)(Obr);